import { Description } from "Features/CheckPrice/Products/Advice/adviceStyled";
import { CoverageNeed } from "Store/akaAdvice/interfaces/CollectiveAdvice";
import React from "react";
import { DisabilityAdviceDescription } from "./DisabilityAdviceDescription";
import { DisabilityAdviceIntroHeader } from "./DisabilityAdviceIntro";

interface Props {
  isAdvisor: boolean;
  coverageNeed: CoverageNeed;
  adviceTexts: any;
  lang: string;
}

export const DisabilityAdviceText = ({
  coverageNeed,
  adviceTexts,
  lang,
}: Props): React.ReactElement => (
  <>
    <DisabilityAdviceIntroHeader adviceTexts={adviceTexts} lang={lang} />
    <Description fw={700} size="16px">
      {adviceTexts.title[lang]}
    </Description>
    <DisabilityAdviceDescription
      need={coverageNeed}
      adviceTexts={adviceTexts}
      lang={lang}
    />
  </>
);
